import React from 'react';
import { useLocalizer } from '../hooks/useLocalizer';

interface BackToGapSummaryButtonProps {
    onBack: () => void;
    trailingAction?: React.ReactNode;
}

export const BackToGapSummaryButton: React.FC<BackToGapSummaryButtonProps> = ({
    onBack,
    trailingAction
}) => {
    const localize = useLocalizer();

    return (
        <div className={`gap-summary-report-nav${trailingAction ? ' gap-summary-report-nav-with-actions' : ''}`}>
            <button type="button" className="btn btn-default" onClick={onBack}>
                <span
                    className="glyphicon glyphicon-arrow-left gap-summary-report-back-icon"
                    aria-hidden="true"
                ></span>
                {localize('Back to Gap Summary')}
            </button>
            {trailingAction}
        </div>
    );
};

export default BackToGapSummaryButton;
